module.exports = __webpack_public_path__ + "img/gr-h-1.31223edc.jpg";